import { SAVINGS_RECEIVED, SAVINGS_UNLOADED, SAVINGS_SAVED, SAVINGS_DELETED } from './types.js'

export default function savings(state = [], action = {}){
  switch (action.type) {
    case SAVINGS_RECEIVED:
      return action.data.sort(function(a, b) {
        let result = 0 
        let aStart = a.bars && a.bars[0] ? parseInt(a.bars[0].startDate, 10) : 0
        let bStart = b.bars && b.bars[0] ? parseInt(b.bars[0].startDate, 10) : 0
        let aAlloc = parseFloat(a.allocation)
        let bAlloc = parseFloat(b.allocation)
        aAlloc += (aAlloc > 0 && aAlloc < 1) ? 0 : 1
        bAlloc += (bAlloc > 0 && bAlloc < 1) ? 0 : 1
        result = (bAlloc - aAlloc) || (a.itemType.localeCompare(b.itemType)) || (aStart-bStart) || (parseInt(a.balance, 10) - parseInt(b.balance, 10)) || (a.description.localeCompare(b.description))
        return result
      })
    case SAVINGS_UNLOADED:
      return []
    case SAVINGS_SAVED:
      let isEdit = false
      const _state = state.map( v => {
        if(v.id === action.data.id){
          isEdit = true
          return action.data
        }else{
          return v
        }
      })
      if(!isEdit){
        return [action.data, ...state]
      }else{
        return _state
      }
    case SAVINGS_DELETED:
      return state.filter(v => v.id !== action.data.id)
    default:
      return state
  }
}
